module.exports = __webpack_public_path__ + "static/media/question-help-circle.c244f14c.svg";